export function isObjectEmpty<T extends object>(obj: T | null | undefined): boolean {
  return obj === null || obj === undefined || Object.keys(obj).length === 0;
}
